import React, { useEffect, useState } from "react";
import { Formik, Form as FormikForm, Field } from "formik";
import * as Yup from "yup";
import {
  addQuestion,
  deleteQuestion,
  getFaqsAllData,
  updateStatus,
} from "../../../store/faqs/faqsThunk";
import { useDispatch, useSelector } from "react-redux";
import { Hourglass } from "react-loader-spinner";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  deleteQuickreply,
  getQuickreplyAllData,
  insertQuickreply,
} from "../../../store/Quickreply/QuickreplyThunk";

const Quickreply = () => {
  const [activeKey, setActiveKey] = useState("0");
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [feedbackMessage, setFeedbackMessage] = useState("");

  const { questions, message, updatemesssge, deletemesssge, getFaqloading } =
    useSelector((state) => state.Faqs);
  const {
    insertQuickreplyLoding,
    insertQuickreplyerrer,
    insertQuickreplySuccess,
    getQuickreplyLoding,
    getQuickreplyerrer,
    getQuickreplySuccess,
    deleteQuickreplySuccess,
    deleteQuickreplyError,
    deleteQuickreplyLoading
  } = useSelector((state) => state.Quickreply);

  let dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(getQuickreplyAllData());
  // }, [deleteQuickreplySuccess]);

  useEffect(() => {
    dispatch(getQuickreplyAllData());
  }, []);

  useEffect(() => {
    dispatch(getFaqsAllData());
  }, [updatemesssge]);

  useEffect(() => {
    const fetchedFaqs = Array.isArray(getQuickreplySuccess?.data)
      ? getQuickreplySuccess.data.filter(item => item && item._id && item.title && item.payload)
      : [];
    setFaqs(fetchedFaqs);
  }, [getQuickreplySuccess]);

  // useEffect(() => {
  //   dispatch(getQuickreplyAllData());
  //   handleCloseModal();
  //   // if (insertQuickreplySuccess) {
  //   //   toast.success('Quick reply added successfully');
  //   // }
  // }, [insertQuickreplySuccess]);


  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    payload: Yup.string().required("Answer is required"),
  });

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = () => {
    dispatch(deleteQuickreply(deleteId)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        setFaqs((prevFaqs) => prevFaqs.filter((faq) => faq._id !== deleteId));
        setShowDeleteModal(false);
        setDeleteId(null);
        toast.success("Quick reply deleted successfully");
      } else {
        toast.error("Failed to delete quick reply");
      }
    }).catch((error) => {
      console.error("Error deleting quick reply:", error);
      toast.error("Failed to delete quick reply");
    });
  };

  const handleSwitchChange = (id) => {
    dispatch(updateStatus(id));
  };

  const handleHeaderClick = (eventKey, e) => {
    if (e.target.closest('.toggle-switch') || e.target.closest('.delete-button')) return;
    setActiveKey(activeKey === eventKey ? null : eventKey);
  };

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setFeedbackMessage("");
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const handleSubmit = (values, { resetForm }) => {
    dispatch(insertQuickreply(values)).then((result) => {
      console.log(result, "resultresultresultresult")
      if (result.meta.requestStatus === "fulfilled" && result.payload?.data) {
        const payload = result.payload;
        console.log(payload, "payloadpayloadpayload")
        console.log(payload.data._id, "payload.data[0]._idpayload.data[0]._idpayload.data[0]._id")
        if (payload) {
          const newQuickReply = {
            _id: payload.data._id,
            userId: payload.data.userId,
            payload: payload.data.payload,
            title: payload.data.title
          };
          setFaqs((prevFaqs) => [...prevFaqs, newQuickReply]);
          resetForm();
          setShowModal(false);
          toast.success("Quick reply added successfully");
        } else {
          toast.error(result.payload.message);
        }
      } else {
        toast.error(result.payload.message);
      }
    }).catch((error) => {
      console.error("Error adding quick reply:", error);
      toast.error(error);
    });
  };


  console.log(faqs, "newQuickReplynewQuickReplynewQuickReply")

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <style jsx>{`
        .glassmorphism {
          background: rgba(255, 255, 255, 0.25);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.18);
        }
        
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        .animate-pulse-slow {
          animation: pulse 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
        
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 10px;
        }
        
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #50B5FF;
          border-radius: 10px;
        }
        
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #3b9ae1;
        }
        
        .gradient-border {
          background: linear-gradient(45deg, #50B5FF, #a855f7, #ec4899);
          background-size: 400% 400%;
          animation: gradientShift 3s ease infinite;
        }
        
        @keyframes gradientShift {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
      `}</style>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        className="mt-16"
        toastClassName="backdrop-blur-sm bg-white/90"
      />

      {getQuickreplyLoding || getFaqloading ? (
        <div className="flex justify-center items-center h-screen">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-[#50B5FF] to-purple-600 opacity-20 animate-ping"></div>
            <Hourglass
              visible={true}
              height="80"
              width="80"
              ariaLabel="hourglass-loading"
              colors={["#50B5FF", "#50B5FF"]}
            />
          </div>
        </div>
      ) : (
        <>
          {/* Decorative Background Elements */}
          {/* <div className="fixed inset-0 overflow-hidden pointer-events-none">
            <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#50B5FF] rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-float"></div>
            <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-400 rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-float" style={{ animationDelay: '2s' }}></div>
            <div className="absolute top-40 left-1/2 w-80 h-80 bg-pink-400 rounded-full mix-blend-multiply filter blur-xl opacity-10 animate-float" style={{ animationDelay: '4s' }}></div>
          </div> */}

          <div className="relative z-2 p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">

              {/* Header Section */}
              <div className="mb-8 lg:mb-12">
                <div className="relative overflow-hidden rounded-3xl bg-[#50B5FF] via-[#50B5FF] to-[#3b9ae1] shadow-2xl">
                  {/* Animated Background Pattern */}
                  <div className="absolute inset-0 opacity-10">
                    <div className="absolute inset-0 bg-transparent via-white to-transparent animate-pulse-slow"></div>
                  </div>

                  <div className="relative px-6 py-6 sm:px-8 sm:py-8 lg:px-12 lg:py-10">
                    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
                      <div className="text-center lg:text-left ">
                        <h1 className="text-[18px] lg:text-left sm:text-[20px] lg:text-[25px] font-bold text-white  mb-[10px]">
                          Quick Reply Management
                        </h1>
                        <p className="text-blue-100 text-[13px] text-center lg:text-left  sm:text-[14px] lg:text-[16px] font-medium ">
                          Manage Quick Reply Messages & Responses
                        </p>
                      </div>
                      <div className="flex justify-center lg:justify-end">
                        <button
                          onClick={handleShowModal}
                          className="group relative px-6 py-3 sm:px-7 sm:py-4 bg-white text-[#50B5FF] rounded-xl font-semibold text-base sm:text-[16px]   transform hover:scale-105 transition-all duration-300 overflow-hidden"
                        >
                          <div className="absolute inset-0 bg-[#50B5FF] to-purple-600 opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
                          <div className="relative flex items-center">
                            <svg className="w-5 h-5 mr-3 transform group-hover:rotate-12 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                            </svg>
                            Add Quick Reply
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {feedbackMessage && (
                  <div className="mt-6 p-4 bg-green-100 border-l-4 border-green-500 text-green-700 rounded-r-xl  animate-pulse">
                    <div className="flex items-center">
                      <svg className="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      {feedbackMessage}
                    </div>
                  </div>
                )}
              </div>

              {/* Quick Reply List */}
              <div className="space-y-4 sm:space-y-6">
                {faqs?.length === 0 ? (
                  <div className="text-center py-16 sm:py-20">
                    <div className="max-w-md mx-auto">
                      <div className="w-24 h-24 mx-auto mb-6 bg-[#50B5FF] to-purple-600 rounded-full flex items-center justify-center">
                        <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
                        </svg>
                      </div>
                      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-3">No Quick Replies Yet</h3>
                      <p className="text-gray-600 mb-6">Start building your quick response library by adding your first quick reply.</p>
                      <button
                        onClick={handleShowModal}
                        className="px-6 py-3 bg-[#50B5FF] text-white rounded-xl font-medium hover:bg-[#3b9ae1] transform hover:scale-105 transition-all duration-300 "
                      >
                        Create First Quick Reply
                      </button>
                    </div>
                  </div>
                ) : (
                  faqs?.map((faq, index) => (
                    faq.title && faq.payload ? (
                      <div key={faq._id} className="group">
                        <div className="bg-white/70 backdrop-blur-sm rounded-2xl   border border-white/50 overflow-hidden transition-all duration-500 hover:transform">
                          {/* Quick Reply Header */}
                          <div
                            className="px-4 sm:px-6 lg:px-8 py-3 sm:py-5 cursor-pointer hover:bg-gradient-to-r hover:from-[#50B5FF]/5 hover:to-purple-600/5 transition-all duration-300"
                            onClick={(e) => handleHeaderClick(index.toString(), e)}
                          >
                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                              <div className="flex items-start space-x-3 sm:space-x-4 flex-1 min-w-0">
                                <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-[#50B5FF] to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-base">
                                  {index + 1}
                                </div>
                                <div className="flex-1 min-w-0">
                                  <h3 className="text-base sm:text-md lg:text-lg font-semibold text-gray-800 mb-1 break-words">
                                    {faq.title}
                                  </h3>
                                  <p className="text-sm text-gray-500">Click to expand response</p>
                                </div>
                              </div>

                              <div className="flex items-center justify-between sm:justify-end space-x-3 sm:space-x-4 flex-shrink-0">
                                {/* Status Badge */}
                                <div className="px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                  Active
                                </div>

                                {/* Action Buttons */}
                                <div className="flex items-center space-x-2">
                                  <button
                                    className="delete-button p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full transition-all duration-200 transform hover:scale-110"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteClick(faq._id);
                                    }}
                                    title="Delete Quick Reply"
                                  >
                                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                                    </svg>
                                  </button>

                                  <div className="hidden sm:block">
                                    <svg
                                      className={`w-5 h-5 text-gray-400 transform transition-all duration-300 ${activeKey === index.toString() ? 'rotate-180' : ''
                                        }`}
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Quick Reply Response */}
                          <div className={`overflow-hidden transition-all duration-500 ease-in-out  ${activeKey === index.toString() ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                            }`}>
                            <div className="px-4 sm:px-6 lg:px-8 py-4 sm:py-6 bg-[#50B5FF]/5 to-purple-600/5 border-t border-gray-100  ">
                              <div className="flex items-start space-x-3 sm:space-x-4">
                                <div className="flex-shrink-0 w-6 h-6 bg-[#50B5FF] to-purple-600 rounded-full flex items-center justify-center">
                                  <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M18 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v8a2 2 0 002 2h3l3 3 3-3h3a2 2 0 002-2zM5 7a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1zm1 3a1 1 0 100 2h3a1 1 0 100-2H6z" clipRule="evenodd" />
                                  </svg>
                                </div>
                                <div className="flex-1">
                                  <p className="text-gray-700 leading-relaxed text-sm sm:text-base break-words custom-scrollbar max-h-32 overflow-y-auto pr-2 ">
                                    {faq.payload}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null
                  ))
                )}
              </div>
            </div>
          </div>

          {/* Add Quick Reply Modal */}
          {showModal && (
            <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
              <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto custom-scrollbar transform animate-in fade-in zoom-in duration-300">
                <div className="sticky top-0 bg-[#50B5FF] p-6 sm:p-8 rounded-t-3xl">
                  <div className="flex justify-between items-center">
                    <div>
                      <h3 className="text-1xl sm:text-2xl font-bold text-white mb-2">Add New Quick Reply</h3>
                      <p className="text-blue-100">Create a new quick response message</p>
                    </div>
                    <button
                      onClick={handleCloseModal}
                      className="p-2 text-white hover:bg-white/20 rounded-full transition-all duration-200 transform hover:scale-110"
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                      </svg>
                    </button>
                  </div>
                </div>

                <div className="p-6 sm:p-8">
                  <Formik
                    initialValues={{ title: "", payload: "" }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ errors, touched }) => (
                      <FormikForm className="space-y-6">
                        <div>
                          <label htmlFor="title" className="block text-sm font-semibold text-gray-800 mb-3">
                            Title *
                          </label>
                          <Field
                            name="title"
                            type="text"
                            placeholder="Enter quick reply title"
                            className={`w-full px-4 py-4 bg-white border-2 rounded-2xl focus:ring-4 focus:ring-[#50B5FF]/20 focus:border-[#50B5FF] outline-none transition-all duration-300 text-base ${touched.title && errors.title ? 'border-red-400' : 'border-gray-200'
                              }`}
                          />
                          {touched.title && errors.title && (
                            <p className="mt-2 text-sm text-red-600 flex items-center">
                              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                              </svg>
                              {errors.title}
                            </p>
                          )}
                        </div>

                        <div>
                          <label htmlFor="payload" className="block text-sm font-semibold text-gray-800 mb-3">
                            Response Message *
                          </label>
                          <Field
                            name="payload"
                            as="textarea"
                            rows={5}
                            placeholder="Enter your quick response message..."
                            className={`w-full px-4 py-4 bg-white border-2 rounded-2xl focus:ring-4 focus:ring-[#50B5FF]/20 focus:border-[#50B5FF] outline-none transition-all duration-300 resize-vertical text-base custom-scrollbar ${touched.payload && errors.payload ? 'border-red-400' : 'border-gray-200'
                              }`}
                          />
                          {touched.payload && errors.payload && (
                            <p className="mt-2 text-sm text-red-600 flex items-center">
                              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                              </svg>
                              {errors.payload}
                            </p>
                          )}
                        </div>

                        <div className="flex flex-col sm:flex-row gap-3 pt-6">
                          <button
                            type="button"
                            onClick={handleCloseModal}
                            className="flex-1 px-6 py-4 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-2xl font-semibold transition-all duration-300 transform hover:scale-105"
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="flex-1 px-6 py-4 bg-[#50B5FF] to-purple-600 text-white rounded-2xl font-semibold hover: transition-all duration-300 transform hover:scale-105"
                          >
                            Add Quick Reply
                          </button>
                        </div>
                      </FormikForm>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          )}

          {/* Delete Confirmation Modal */}
          {showDeleteModal && (
            <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
              <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full transform animate-in fade-in zoom-in duration-300">
                <div className="p-6 sm:p-8 text-center">
                  <div className="w-16 h-16 mx-auto mb-6 bg-red-100 rounded-full flex items-center justify-center">
                    <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                    </svg>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">Delete Quick Reply</h3>
                  <p className="text-gray-600 mb-8">Are you sure you want to delete this quick reply? This action cannot be undone.</p>

                  <div className="flex flex-col sm:flex-row gap-3">
                    <button
                      onClick={handleCloseDeleteModal}
                      className="flex-1 px-6 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-2xl font-semibold transition-all duration-300 transform hover:scale-105"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleDeleteConfirm}
                      className="flex-1 px-6 py-3 bg-red-500 to-red-600 text-white rounded-2xl font-semibold hover: transition-all duration-300 transform hover:scale-105"
                    >
                      Delete Quick Reply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Quickreply;